import supabase from '../lib/supabase';
import type { ThemePreference } from '../theme/preference';

/** Only personal auth metadata, never tenant settings or application records. */
export async function saveThemePreference(value: ThemePreference): Promise<void> {
  const { error } = await supabase.auth.updateUser({ data: { collectr_operator_theme: value } });
  if (error) throw error;
}
